var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2791 6.98534L24.0148 9.71979L21.2791 6.98534ZM23.0383 4.57638L15.641 11.9738C15.2587 12.3554 14.9981 12.8417 14.8918 13.3713L14.2085 16.7917L17.6288 16.1071C18.1584 16.0012 18.6441 15.7415 19.0264 15.3592L26.4238 7.96184C26.6461 7.73954 26.8224 7.47564 26.9427 7.1852C27.063 6.89477 27.1249 6.58347 27.1249 6.26911C27.1249 5.95474 27.063 5.64345 26.9427 5.35301C26.8224 5.06257 26.6461 4.79867 26.4238 4.57638C26.2015 4.35408 25.9376 4.17775 25.6472 4.05745C25.3567 3.93714 25.0454 3.87523 24.7311 3.87523C24.4167 3.87523 24.1054 3.93714 23.815 4.05745C23.5245 4.17775 23.2606 4.35408 23.0383 4.57638V4.57638Z",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5417 19.375V23.25C24.5417 23.9351 24.2696 24.5922 23.7851 25.0767C23.3006 25.5612 22.6436 25.8333 21.9584 25.8333H7.75008C7.06494 25.8333 6.40786 25.5612 5.92339 25.0767C5.43892 24.5922 5.16675 23.9351 5.16675 23.25V9.04167C5.16675 8.35653 5.43892 7.69945 5.92339 7.21498C6.40786 6.73051 7.06494 6.45834 7.75008 6.45834H11.6251",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.c0b82d741c65e4eb447fa91ff32746ea.svg";
export { ForwardRef as ReactComponent };